import { render, staticRenderFns } from "./PassangerCar.vue?vue&type=template&id=8406e644&"
import script from "./PassangerCar.vue?vue&type=script&lang=ts&"
export * from "./PassangerCar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports